import { SortType } from "@/interfaces/lists"
import { ListContributorViewOptions } from "../../elements/lists/ViewToggle"
import LoadingCircle from "../global/LoadingCircle/LoadingCircle"

export const ViewOptionButtonPlaceHolder =  ({viewOption}: {viewOption: ListContributorViewOptions}) => (
    <>View:<span style={{fontWeight: 700, margin: '0 5px'}}>{viewOption.toString()}</span></>
)

export const viewOptionAriaLabel = (viewOption: ListContributorViewOptions) => (
    `list is currently filter to display ${viewOption}, click to change`
)

export const AddNewContentButtonContent = ({isOpen}:{isOpen:boolean}) => {
    return isOpen ? <span>Cancel</span> : <span className="new-button"><span>New</span><span className='plus'>+</span></span>
}

export const SavingListAsDraft = () => (
    <span className="saving-draft-list"><span>Saving List as draft</span> <span className='loading-circle'><LoadingCircle /></span></span>
)

export const listTableColumns = [
    {title: 'Title', isToggleButton: false},
    {title: 'Audience', isToggleButton: false},
    {title: 'Your Access', isToggleButton: false}
]

export const mainMenuTableColumns = [
    {title: 'Title', isToggleButton: false},
    {title: 'Audience', isToggleButton: false},
    {title: 'Your Access', isToggleButton: false}
]

export function reverseMapSortTypeEnum(sortType: SortType) {
    switch (sortType) {
        case SortType.DateCreatedNewest:
            return 'Date Created (Newest)'
        case SortType.DateCreatedOldest:
            return 'Date Created (Oldest)';
        case SortType.DateModifiedNewest:
            return 'Date Modified (Newest)';
        case SortType.DateModifiedOldest:
            return 'Date Modified (Oldest)';
        case SortType.TitleAZ:
            return 'Title (A - Z)';
        case SortType.TitleZA:
            return 'Title (Z - A)';
        case SortType.Manual:
            return 'Manual';
    }
}